function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    dy: ".35em",
    style: {
      fontSize: 14,
      fontFamily: "'Helvetica Neue',Arial,Helvetica,sans-serif",
      fontWeight: "bold",
      textAnchor: "middle"
    }
  }, "3D"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3D.e8952c5e30f5ac855587503896619a13.svg";
export { ForwardRef as ReactComponent };